import SockJS from 'sockjs-client'
import Stomp from 'stompjs'
export default {
  namespaced: true,
  state: {
    currurl: '111',
    stompClient: {},
    stat: ''
  },
  getters: {
    geturl(state) {
      return state.url
    },
    getstompClient(state) {
      return state.stompClient
    },
    getstat(state) {
      return state.stat
    }
  },
  actions: {
    changurl({ state, dispatch }) {

    }
  },
  mutations: {
    /**
         * @description 设置顶栏菜单
         * @param {Object} state vuex state
         * @param {Array} menu menu setting
         */
    changurl(state, url) {
      state.currurl = url.path
    },
    setsocker(state) {
      const base = process.env.VUE_APP_WSAPI

      // const url = base + 'websocket/reg?token=' + this.$store.state.user.token
      const socket = new SockJS(base)
      // 获取STOMP子协议的客户端对象
      state.stompClient = Stomp.over(socket)

      // state.stompClient.connect(headers, () => {
      //   state.stompClient.subscribe('')
      // }, err => {
      //
      // })
    },
    setstat(state, newstate) {
      state.stat = newstate
    }
  }

}
